import React from "react";
import {Bar} from 'react-chartjs-2';
import HistogramAssembler from "./HistogramAssembler";


const Histogram = ({data: jsonData}) => {
    const histogramAssembler = new HistogramAssembler();
    const {data, options} = histogramAssembler.toChartJs(jsonData);
    return (
        <div className="chart-area">
            <Bar
                data={data}
                options={options}
            />
        </div>
    )
};

export default Histogram;
